import {
  FaAddressCard,
  FaInfoCircle,
  FaMailBulk,
  FaPhoneAlt,
  FaRegAddressCard,
} from "react-icons/fa";
import Collabse from "../../components/Collabse";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { useEffect } from "react";
import { loaderActions } from "../../redux/slices/loadingSlice";
import useCookiesCheck from "../../utils/useCookiesCheck";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";
import { ImExit } from "react-icons/im";
import { MdEditDocument } from "react-icons/md";

const InfoPage = () => {
  const { t } = useTranslation();
  useCookiesCheck();
  const booking = useAppSelector((state) => state.booking);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const errorMessages = {
    isExpired: t("bookingDetails.overview.expiredBooking"),
    isCanceled: t("bookingDetails.overview.cancelledBooking"),
  };

  useEffect(() => {
    dispatch(loaderActions.hideLoader());
  }, []);

  const isAdmin = sessionStorage.getItem("adminAuthenticated") === "true";

  const logout = () => {
    sessionStorage.removeItem("lmxBooking");
    window.location.href = "/MyLmxApp";
  };

  return (
    <div className="container mt-5">
      <div className="flex items-center gap-2 justify-end mb-4">
        {isAdmin && (
          <button
            className="btnRounded flex items-center gap-3"
            onClick={() => navigate("/admin/booking")}
          >
            <MdEditDocument />
            Change Booking
          </button>
        )}
        <button className="btnRounded flex items-center gap-3" onClick={logout}>
          <ImExit />
          Logout
        </button>
      </div>
      <Collabse Header={Header}>
        <div className="row">
          <p style={{ color: "darkorange" }}>
            {booking.isCanceled
              ? errorMessages.isCanceled
              : errorMessages.isExpired}
          </p>

          <div className="col-12 col-lg-6">
            <p>
              <FaAddressCard />
              &emsp;{booking.travelAgency?.addressLine}
              <br />
              <span>&emsp;&emsp;{booking.travelAgency.street}</span>
              <span> {booking.travelAgency.streetNo}</span>
              <br />
              <span>&emsp;&emsp;{booking.travelAgency.postalCode}</span>
              <span> {booking.travelAgency.city}</span>
              <br />
              <span>
                <FaPhoneAlt />
                &emsp;{booking.travelAgency.phoneBusiness}
              </span>
              <br />
              <span>
                <FaMailBulk />
                &emsp;{booking.travelAgency.email}
              </span>
              <br />
            </p>
          </div>
        </div>
      </Collabse>
    </div>
  );
};

const Header = () => {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <h5>
          <FaRegAddressCard />
          {t("bookingDetails.overview.title1")}
        </h5>
      </div>
      <div className="col-12 col-lg-6">
        <h5>
          <FaInfoCircle />
          {t("bookingDetails.overview.title2")}
        </h5>
      </div>
    </div>
  );
};

export default InfoPage;
